export default "__VITE_ASSET__CY6y_Uz4__"